"use client";

import CommonImage from "@/components/common/image/CommonImage";
import { Modal } from "antd";
import { motion } from "framer-motion";
import Link from "next/link";
import Image from "next/image";
import React, { useState, useEffect } from "react";
import { FaCirclePlay } from "react-icons/fa6";
import HomePageService from "@/services/api/HomeService";
import { FaPhoneVolume, FaYoutube } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { useSelector } from "react-redux";
import CommonService from "@/services/api/CommonService";
import AboutSection from './../home/components/AboutSection';
import FAQPage from "../faqs/FAQPage";
import AntImage from "@/components/common/image/AntImage";

const bgClasses = [
  "bg-blue",
  "bg-orange",
  "bg-purple",
  "bg-green",
  "bg-vivid",
  "bg-blue",
];


export default function AboutUs() {
  const setting = useSelector((state) => state.setting.data);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [about, setAbout] = useState({});
  console.log("about",about)
  const [loading, setLoading] = useState(false);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const fetchData = async () => {
    setLoading(true);
    try {

      const aboutRes = await CommonService.getAbout();
      if (aboutRes) setAbout(aboutRes);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="about-page">

      <div className="about-hero_section section_padding !pb-0 bg-fill-white">
        <div className="container">
          <div className="grid grid-cols-12">

            <div className="col-span-12 xl:col-span-10 xl:col-start-2">
              <div className="top-btn">
                <div className="image-wrap">
                  <CommonImage
                    src="/images/admission-icon/about.avif"
                    alt="Image"
                    className="icon"
                  />
                </div>
                <span>ফোকাস সম্পর্কে</span>
              </div>
            </div>
            <div className="col-span-12 xl:col-span-10 xl:col-start-2">
              <div className="grid grid-cols-10 lx:gap-6 gap-4 hero-content">

                {/* Right */}
                <div className="right-part lg:col-span-4 col-span-10">
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="hero-image"
                  >
                    <AntImage
                      src={about?.center_image ? `https://img.youtube.com/vi/${about.video_id}/maxresdefault.jpg` : "/images/home/about-us.png"}
                      alt="Hero Image"
                      className="hero-img"
                      fill
                    />
 
                  </motion.div>
                </div>

                <div className="left-part lg:col-span-6 col-span-10">
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="hero-text"
                  >
                    <h1 className="main-title">
                      {about?.title}                       
                    </h1>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                  >

                    <div className="details-textarea">
                      {about?.short_description}
                      </div>
                     
                  </motion.div>
                </div>

              </div>
            </div>
          </div>
        </div>
        {/* Video Modal */}
        {/* <Modal
          open={isModalOpen}
          onCancel={handleCancel}
          footer={null}
          centered
          width={800}
          className="video-modal"
          styles={{ body: { padding: 0 } }}
          destroyOnHidden
        >
          <div className="aspect-video w-full">
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${about?.video_id ?? "dQw4w9WgXcQ"
                }?autoplay=1`}
              title="YouTube Video"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </div>
        </Modal> */}
      </div>
      <AboutSection bgClass={'about-bg'}/>
      <FAQPage />
    </div>
  );
}
